import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class ExperienceUsersStateModel extends PaginatedSubentityStateModel {
    constructor() {
        super('ExperienceUsersStateModel');
    }
}
